export default "__VITE_ASSET__KYWmvB2w__"